import React from 'react';
import {
    Stack,
    ToggleButton,
    ToggleButtonGroup,
} from '@mui/material';
import { colors } from 'features/userData/style';
import * as geoConfig from 'config/geocoder/config';

const AddrCoordToggle = ({
    showReverse,
    setShowReverse
}) => {
    return (
        <Stack direction="row" justifyContent="flex-end" sx={{ mb: 1, }}>
            <ToggleButtonGroup
                size="small"
                exclusive
                value={showReverse ? 'reverse' : 'forward'}
                onChange={(_, v) => {
                    if (!v) return;
                    setShowReverse(v === 'reverse');
                }}
                sx={{
                    width: '100%',
                    '& .MuiToggleButton-root': { 
                        flex: 1, 
                        px: 1.5,
                        py: 0.5,
                        color: '#323232', 
                        fontWeight: 500,
                    },
                    '& .MuiToggleButton-root.Mui-selected': {
                        bgcolor: geoConfig.themeColor,
                        color: '#fff',
                        '&:hover': { bgcolor: colors.primaryBlue },
                    },
                }}
            >
                <ToggleButton value="forward">주소로 입력</ToggleButton>
                <ToggleButton value="reverse">좌표로 입력</ToggleButton>
            </ToggleButtonGroup>
        </Stack>
    );
};

export default AddrCoordToggle;